// extracted by mini-css-extract-plugin
export default {"no_button":"PromptModal_no_button__5VN29","common_button":"PromptModal_common_button__Y-aq1","yes_no":"PromptModal_yes_no__d7Pd0","yes_button":"PromptModal_yes_button__k3seN"};